<template>
    <div>
        <b-carousel id="carousel"
                    style="text-shadow: 1px 1px 2px #333;"
                    background="#ababab"
                    :interval="4000"
                    img-width="1024"
                    img-height="480">
            <b-carousel-slide :img-src="this.getIllu('illu_01')"></b-carousel-slide>
            <b-carousel-slide :img-src="this.getIllu('illu_02')"></b-carousel-slide>
            <b-carousel-slide :img-src="this.getIllu('illu_03')"></b-carousel-slide>
            <b-carousel-slide :img-src="this.getIllu('illu_04')"></b-carousel-slide>
            <b-carousel-slide :img-src="this.getIllu('illu_05')"></b-carousel-slide>
        </b-carousel>
    </div>
</template>

<script>
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'Jumbotron',
        methods: {
            getIllu (illuName) {
                let images = require.context('../assets/images/illus/', false, /\.png$/)
                let imageName = i18n.t('jumbotron.' + illuName)
                return images('./' + imageName)
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/JumbotronComponent.vue